// import React, { useState, useEffect, useMemo } from 'react';
// import { 
//   Table, 
//   TableBody, 
//   TableCell, 
//   TableContainer, 
//   TableHead, 
//   TableRow, 
//   Paper, 
//   Button, 
//   Dialog, 
//   DialogTitle, 
//   DialogContent, 
//   TextField,
//   Select,
//   MenuItem,
//   Grid,
//   IconButton,
//   DialogActions,
//   Chip,
//   FormControl,
//   InputLabel,
//   Box,
//   Typography,
//   ImageList,
//   ImageListItem,
//   Tabs,
//   Tab
// } from '@mui/material';
// import { Close as CloseIcon, Image as ImageIcon } from '@mui/icons-material';
// import axios from 'axios';

// const AllProducts = () => {
//   const [products, setProducts] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [searchProductId, setSearchProductId] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('All');
//   const [activeTab, setActiveTab] = useState(0);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get('/api/products');
//         setProducts(response.data);
//       } catch (error) {
//         console.error('Error fetching products:', error);
//       }
//     };
//     fetchProducts();
//   }, []);

//   const categories = useMemo(() => {
//     const uniqueCategories = ['All', ...new Set(products.map(product => product.categories[0].name))];
//     return uniqueCategories;
//   }, [products]);

//   const filteredProducts = useMemo(() => {
//     return products.filter(product => {
//       const matchesCategory = selectedCategory === 'All' || 
//         product.categories[0].name === selectedCategory;
//       const matchesSearch = product.productId.toString().includes(searchProductId);
//       return matchesCategory && matchesSearch;
//     });
//   }, [products, selectedCategory, searchProductId]);

//   const handleEditProduct = async () => {
//     try {
//       const salePrice = selectedProduct.originalPrice * (1 - selectedProduct.discount / 100);
//       const updatedProductData = {
//         ...selectedProduct,
//         salePrice: Math.round(salePrice)
//       };
//       await axios.put(`/api/products/${selectedProduct._id}`, updatedProductData);
//       const response = await axios.get('/api/products');
//       setProducts(response.data);
//       setOpenEditModal(false);
//     } catch (error) {
//       console.error('Error updating product:', error);
//     }
//   };

//   const TabPanel = ({ children, value, index }) => (
//     <div hidden={value !== index}>
//       {value === index && children}
//     </div>
//   );

//   return (
//     <div className="p-6">
//       <Typography variant="h4" className="mb-6">Stock Management</Typography>

//       <Box className="flex flex-col gap-4">
//         <Box className="flex gap-4 mb-4">
//           <TextField
//             label="Search by Product ID"
//             variant="outlined"
//             value={searchProductId}
//             onChange={(e) => setSearchProductId(e.target.value)}
//             className="flex-1"
//           />

//           <FormControl className="min-w-[200px]">
//             <InputLabel>Filter by Category</InputLabel>
//             <Select
//               value={selectedCategory}
//               label="Filter by Category"
//               onChange={(e) => setSelectedCategory(e.target.value)}
//             >
//               {categories.map((category) => (
//                 <MenuItem key={category} value={category}>{category}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>

//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Product Image</TableCell>
//                 <TableCell>Product ID</TableCell>
//                 <TableCell>Product Name</TableCell>
//                 <TableCell>Category</TableCell>
//                 <TableCell>Price Details</TableCell>
//                 <TableCell>Size Available</TableCell>
//                 <TableCell>Material</TableCell>
//                 <TableCell>Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredProducts.map((product) => (
//                 <TableRow key={product._id}>
//                   <TableCell>
//                     <img
//                       src={`${product.images[0]?.url}`}
//                       alt={product.productName}
//                       className="w-16 h-16 object-cover rounded"
//                       onError={(e) => {
//                         e.target.src = "/api/placeholder/64/64";
//                       }}
//                     />
//                   </TableCell>
//                   <TableCell>{product.productId}</TableCell>
//                   <TableCell>
//                     <Typography variant="body1">{product.productName}</Typography>
//                     <Typography variant="caption" color="textSecondary">
//                       {product.description}
//                     </Typography>
//                   </TableCell>
//                   <TableCell>{product.categories[0].name}</TableCell>
//                   <TableCell>
//                     <div>
//                       <Typography variant="body2">Original: ₹{product.originalPrice}</Typography>
//                       <Typography variant="body2">Discount: {product.discount}%</Typography>
//                       <Typography variant="body2" color="primary">Sale: ₹{product.salePrice}</Typography>
//                     </div>
//                   </TableCell>
//                   <TableCell>
//                     <div className="flex flex-wrap gap-1">
//                       {product.size.map((sizeItem) => (
//                         <Chip
//                           key={sizeItem.sizeId}
//                           label={`${sizeItem.size} (${sizeItem.quantity})`}
//                           size="small"
//                           color={sizeItem.quantity > 0 ? "success" : "error"}
//                         />
//                       ))}
//                     </div>
//                   </TableCell>
//                   <TableCell>{product.material}</TableCell>
//                   <TableCell>
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       onClick={() => {
//                         setSelectedProduct(product);
//                         setOpenEditModal(true);
//                       }}
//                     >
//                       Edit Details
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Box>

//       <Dialog 
//         open={openEditModal} 
//         onClose={() => setOpenEditModal(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle>
//           Edit Product Details
//           <IconButton 
//             onClick={() => setOpenEditModal(false)} 
//             className="absolute right-2 top-2"
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           {selectedProduct && (
//             <Box>
//               <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
//                 <Tab label="Basic Details" />
//                 <Tab label="Inventory" />
//                 <Tab label="Images" />
//                 <Tab label="Delivery" />
//               </Tabs>

//               <TabPanel value={activeTab} index={0}>
//                 <Grid container spacing={3} className="mt-4">
//                   <Grid item xs={6}>
//                     <TextField
//                       label="Product Name"
//                       fullWidth
//                       value={selectedProduct.productName}
//                       onChange={(e) => setSelectedProduct({
//                         ...selectedProduct,
//                         productName: e.target.value
//                       })}
//                     />
//                   </Grid>
//                   <Grid item xs={6}>
//                     <TextField
//                       label="Material"
//                       fullWidth
//                       value={selectedProduct.material}
//                       onChange={(e) => setSelectedProduct({
//                         ...selectedProduct,
//                         material: e.target.value
//                       })}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       label="Description"
//                       fullWidth
//                       multiline
//                       rows={3}
//                       value={selectedProduct.description}
//                       onChange={(e) => setSelectedProduct({
//                         ...selectedProduct,
//                         description: e.target.value
//                       })}
//                     />
//                   </Grid>
//                 </Grid>
//               </TabPanel>

//               <TabPanel value={activeTab} index={1}>
//                 <TableContainer className="mt-4">
//                   <Table>
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Size</TableCell>
//                         <TableCell>Size ID</TableCell>
//                         <TableCell>Quantity</TableCell>
//                         <TableCell>Status</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {selectedProduct.size.map((sizeItem, index) => (
//                         <TableRow key={sizeItem.sizeId}>
//                           <TableCell>{sizeItem.size}</TableCell>
//                           <TableCell>{sizeItem.sizeId}</TableCell>
//                           <TableCell>
//                             <TextField
//                               type="number"
//                               value={sizeItem.quantity}
//                               onChange={(e) => {
//                                 const updatedSizes = [...selectedProduct.size];
//                                 updatedSizes[index].quantity = parseInt(e.target.value);
//                                 setSelectedProduct({
//                                   ...selectedProduct,
//                                   size: updatedSizes
//                                 });
//                               }}
//                               size="small"
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <Chip 
//                               label={sizeItem.quantity > 0 ? "In Stock" : "Out of Stock"}
//                               color={sizeItem.quantity > 0 ? "success" : "error"}
//                             />
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </TabPanel>

//               <TabPanel value={activeTab} index={2}>
//                 <ImageList cols={3} gap={16} className="mt-4">
//                   {selectedProduct.images.map((image, index) => (
//                     <ImageListItem key={image._id}>
//                       <img
//                         src={`${image.url}`}
//                         alt={`Product ${index + 1}`}
//                         className="w-full h-48 object-cover rounded"
//                         onError={(e) => {
//                           e.target.src = "/api/placeholder/300/200";
//                         }}
//                       />
//                     </ImageListItem>
//                   ))}
//                 </ImageList>
//               </TabPanel>

//               <TabPanel value={activeTab} index={3}>
//                 <Grid container spacing={2} className="mt-4">
//                   <Grid item xs={12}>
//                     <Typography variant="h6">Delivery Duration (Days)</Typography>
//                   </Grid>
//                   {selectedProduct.deliveryDuration.map((duration, index) => (
//                     <Grid item xs={2} key={index}>
//                       <TextField
//                         label={`Option ${index + 1}`}
//                         type="number"
//                         fullWidth
//                         value={duration}
//                         onChange={(e) => {
//                           const updatedDuration = [...selectedProduct.deliveryDuration];
//                           updatedDuration[index] = parseInt(e.target.value);
//                           setSelectedProduct({
//                             ...selectedProduct,
//                             deliveryDuration: updatedDuration
//                           });
//                         }}
//                       />
//                     </Grid>
//                   ))}
//                 </Grid>
//               </TabPanel>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEditModal(false)}>Cancel</Button>
//           <Button onClick={handleEditProduct} variant="contained" color="primary">
//             Save Changes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default AllProducts;



// import React, { useState, useEffect, useMemo } from 'react';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   TextField,
//   Select,
//   MenuItem,
//   Grid,
//   IconButton,
//   DialogActions,
//   Chip,
//   FormControl,
//   InputLabel,
//   Box,
//   Typography,
//   ImageList,
//   ImageListItem,
//   Tabs,
//   Tab,
//   TablePagination
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';
// import axios from 'axios';
// import SideNavbaBarDashboard from '../SideNavaBarDashboard/SideNavbaBarDashboard';
// import AdminHome from './AdminHome';

// const AllProducts = () => {
//   const [products, setProducts] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const [searchProductId, setSearchProductId] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('All');
//   const [activeTab, setActiveTab] = useState(0);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get('/api/products');
//         setProducts(response.data);
//       } catch (error) {
//         console.error('Error fetching products:', error);
//       }
//     };
//     fetchProducts();
//   }, []);

//   const categories = useMemo(() => {
//     const uniqueCategories = ['All', ...new Set(products.map(product => product.categories[0].name))];
//     return uniqueCategories;
//   }, [products]);

//   const filteredProducts = useMemo(() => {
//     return products.filter(product => {
//       const matchesCategory = selectedCategory === 'All' ||
//         product.categories[0].name === selectedCategory;
//       const matchesSearch = product.productId.toString().includes(searchProductId);
//       return matchesCategory && matchesSearch;
//     });
//   }, [products, selectedCategory, searchProductId]);

//   const paginatedProducts = useMemo(() => {
//     return filteredProducts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
//   }, [filteredProducts, page, rowsPerPage]);

//   const handleEditProduct = async () => {
//     try {
//       const salePrice = selectedProduct.originalPrice * (1 - selectedProduct.discount / 100);
//       const updatedProductData = {
//         ...selectedProduct,
//         salePrice: Math.round(salePrice)
//       };
//       await axios.put(`/api/products/${selectedProduct._id}`, updatedProductData);
//       const response = await axios.get('/api/products');
//       setProducts(response.data);
//       setOpenEditModal(false);
//     } catch (error) {
//       console.error('Error updating product:', error);
//     }
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const TabPanel = ({ children, value, index }) => (
//     <div hidden={value !== index}>
//       {value === index && children}
//     </div>
//   );

//   return (
//     <section >
//                           <div className="tf-page-title style-2">
//                 <div className="container-full">
//                     <div className="heading text-center">Stock Management</div>
//                 </div>
//             </div>
//       <div className="container">
//         <div className="row">
          
//           <AdminHome />
//           <div className='col-lg-9'>
//             <Typography variant="h4" className="mb-6"></Typography>

//             <Paper className="mb-6 p-4">
//               <Grid container spacing={2} alignItems="center">
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     label="Search by Product ID"
//                     variant="outlined"
//                     value={searchProductId}
//                     onChange={(e) => setSearchProductId(e.target.value)}
//                     fullWidth
//                     size="small"
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <FormControl fullWidth size="small">
//                     <InputLabel>Filter by Category</InputLabel>
//                     <Select
//                       value={selectedCategory}
//                       label="Filter by Category"
//                       onChange={(e) => setSelectedCategory(e.target.value)}
//                     >
//                       {categories.map((category) => (
//                         <MenuItem key={category} value={category}>{category}</MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Paper>

//             <Paper>
//               <TableContainer>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Product Image</TableCell>
//                       <TableCell>Product ID</TableCell>
//                       <TableCell>Product Name</TableCell>
//                       <TableCell>Category</TableCell>
//                       <TableCell>Price Details</TableCell>
//                       <TableCell>Size Available</TableCell>
//                       <TableCell>Material</TableCell>
//                       <TableCell>Actions</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {paginatedProducts.map((product) => (
//                       <TableRow key={product._id}>
//                         <TableCell>
//                           <div className="w-12 h-12">
//                             <img
//                               src={`${product.images[0]?.url}`}
//                               alt={product.productName}
//                               className="w-full h-full object-cover rounded"
//                               onError={(e) => {
//                                 e.target.src = "/api/placeholder/48/48";
//                               }}
//                             />
//                           </div>
//                         </TableCell>
//                         <TableCell>{product.productId}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2">{product.productName}</Typography>
//                           <Typography variant="caption" color="textSecondary" className="line-clamp-1">
//                             {product.description}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{product.categories[0].name}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2">₹{product.originalPrice}</Typography>
//                           <Typography variant="caption" color="error">-{product.discount}%</Typography>
//                           <Typography variant="body2" color="primary">₹{product.salePrice}</Typography>
//                         </TableCell>
//                         {/* <TableCell>
//                     <div className="flex flex-wrap gap-1 max-w-[200px]">
//                       {product.size.map((sizeItem) => (
//                         <Chip
//                           key={sizeItem.sizeId}
//                           label={`${sizeItem.size} ${sizeItem.quantity}`}
//                           size="small"
//                           color={sizeItem.quantity > 0 ? "success" : "error"}
//                         />
//                       ))}
//                     </div>
//                   </TableCell> */}
//                         <TableCell>
//                           <div className="flex flex-wrap gap-1 max-w-[200px]">
//                             {product.size.map((sizeItem) => (
//                               <Chip
//                                 key={sizeItem.sizeId}
//                                 label={`Size: ${sizeItem.size}, Quantity: ${sizeItem.quantity}`}
//                                 size="small"
//                                 color={sizeItem.quantity > 0 ? "success" : "error"}
//                               />
//                             ))}
//                           </div>
//                         </TableCell>
//                         <TableCell>{product.material}</TableCell>
//                         <TableCell>
//                           <Button
//                             variant="contained"
//                             color="primary"
//                             size="small"
//                             onClick={() => {
//                               setSelectedProduct(product);
//                               setOpenEditModal(true);
//                             }}
//                           >
//                             Edit
//                           </Button>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//               <TablePagination
//                 component="div"
//                 count={filteredProducts.length}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 rowsPerPage={rowsPerPage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 rowsPerPageOptions={[5, 10, 25, 50]}
//               />
//             </Paper>

//             <Dialog
//               open={openEditModal}
//               onClose={() => setOpenEditModal(false)}
//               maxWidth="lg"
//               fullWidth
//             >
//               <DialogTitle>
//                 Edit Product Details
//                 <IconButton
//                   onClick={() => setOpenEditModal(false)}
//                   className="absolute right-2 top-2"
//                 >
//                   <CloseIcon />
//                 </IconButton>
//               </DialogTitle>
//               <DialogContent>
//                 {selectedProduct && (
//                   <Box>
//                     <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
//                       <Tab label="Basic Details" />
//                       <Tab label="Inventory" />
//                       <Tab label="Images" />
//                       <Tab label="Delivery" />
//                     </Tabs>

//                     <TabPanel value={activeTab} index={0}>
//                       <Grid container spacing={3} className="mt-4">
//                         <Grid item xs={6}>
//                           <TextField
//                             label="Product Name"
//                             fullWidth
//                             value={selectedProduct.productName}
//                             onChange={(e) => setSelectedProduct({
//                               ...selectedProduct,
//                               productName: e.target.value
//                             })}
//                           />
//                         </Grid>
//                         <Grid item xs={6}>
//                           <TextField
//                             label="Material"
//                             fullWidth
//                             value={selectedProduct.material}
//                             onChange={(e) => setSelectedProduct({
//                               ...selectedProduct,
//                               material: e.target.value
//                             })}
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <TextField
//                             label="Description"
//                             fullWidth
//                             multiline
//                             rows={3}
//                             value={selectedProduct.description}
//                             onChange={(e) => setSelectedProduct({
//                               ...selectedProduct,
//                               description: e.target.value
//                             })}
//                           />
//                         </Grid>
//                       </Grid>
//                     </TabPanel>

//                     <TabPanel value={activeTab} index={1}>
//                       <TableContainer className="mt-4">
//                         <Table size="small">
//                           <TableHead>
//                             <TableRow>
//                               <TableCell>Size</TableCell>
//                               <TableCell>Size ID</TableCell>
//                               <TableCell>Quantity</TableCell>
//                               <TableCell>Status</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             {selectedProduct.size.map((sizeItem, index) => (
//                               <TableRow key={sizeItem.sizeId}>
//                                 <TableCell>{sizeItem.size}</TableCell>
//                                 <TableCell>{sizeItem.sizeId}</TableCell>
//                                 <TableCell>
//                                   <TextField
//                                     type="number"
//                                     value={sizeItem.quantity}
//                                     onChange={(e) => {
//                                       const updatedSizes = [...selectedProduct.size];
//                                       updatedSizes[index].quantity = parseInt(e.target.value);
//                                       setSelectedProduct({
//                                         ...selectedProduct,
//                                         size: updatedSizes
//                                       });
//                                     }}
//                                     size="small"
//                                   />
//                                 </TableCell>
//                                 <TableCell>
//                                   <Chip
//                                     label={sizeItem.quantity > 0 ? "In Stock" : "Out of Stock"}
//                                     color={sizeItem.quantity > 0 ? "success" : "error"}
//                                     size="small"
//                                   />
//                                 </TableCell>
//                               </TableRow>
//                             ))}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </TabPanel>

//                     <TabPanel value={activeTab} index={2}>
//                       <ImageList cols={3} gap={16} className="mt-4">
//                         {selectedProduct.images.map((image, index) => (
//                           <ImageListItem key={image._id}>
//                             <img
//                               src={`${image.url}`}
//                               alt={`Product ${index + 1}`}
//                               className="w-full h-32 object-cover rounded"
//                               onError={(e) => {
//                                 e.target.src = "/api/placeholder/300/128";
//                               }}
//                             />
//                           </ImageListItem>
//                         ))}
//                       </ImageList>
//                     </TabPanel>

//                     <TabPanel value={activeTab} index={3}>
//                       <Grid container spacing={2} className="mt-4">
//                         <Grid item xs={12}>
//                           <Typography variant="h6">Delivery Duration (Days)</Typography>
//                         </Grid>
//                         {selectedProduct.deliveryDuration.map((duration, index) => (
//                           <Grid item xs={2} key={index}>
//                             <TextField
//                               label={`Option ${index + 1}`}
//                               type="number"
//                               fullWidth
//                               value={duration}
//                               size="small"
//                               onChange={(e) => {
//                                 const updatedDuration = [...selectedProduct.deliveryDuration];
//                                 updatedDuration[index] = parseInt(e.target.value);
//                                 setSelectedProduct({
//                                   ...selectedProduct,
//                                   deliveryDuration: updatedDuration
//                                 });
//                               }}
//                             />
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </TabPanel>
//                   </Box>
//                 )}
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setOpenEditModal(false)}>Cancel</Button>
//                 <Button onClick={handleEditProduct} variant="contained" color="primary">
//                   Save Changes
//                 </Button>
//               </DialogActions>
//             </Dialog>
//           </div>
//         </div>
//       </div>

//       <div className="btn-sidebar-account">
//         <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
//           <i className="icon icon-sidebar-2"></i>
//         </button>
//       </div>

//       <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
//         <div className="canvas-wrapper">
//           <header className="canvas-header">
//             <span className="title">SIDEBAR ACCOUNT</span>
//             <AdminHome />
//             <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
//           </header>
//           <div className="canvas-body sidebar-mobile-append"> </div>
//         </div>
//       </div>

//     </section>
//   );
// };

// export default AllProducts;


import React, { useState, useEffect, useMemo } from 'react';
 import { IoCloseSharp } from "react-icons/io5";
 import { BsMenuButtonWideFill } from "react-icons/bs";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Select,
  MenuItem,
  Grid,
  IconButton,
  DialogActions,
  Chip,
  FormControl,
  InputLabel,
  Box,
  Typography,
  ImageList,
  ImageListItem,
  Tabs,
  Tab,
  TablePagination
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'; // Correct import for delete icon
import { Close as CloseIcon,  Delete as DeleteIcon } from '@mui/icons-material';
import axios from 'axios';
import SideNavbaBarDashboard from '../SideNavaBarDashboard/SideNavbaBarDashboard';
import AdminHome from './AdminHome';
import { 
 
  LinearProgress,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [searchProductId, setSearchProductId] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [activeTab, setActiveTab] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('/api/all/products');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  const categories = useMemo(() => {
    const uniqueCategories = ['All', ...new Set(products.map(product => product.categories[0].name))];
    return uniqueCategories;
  }, [products]);

  const filteredProducts = useMemo(() => {
    return products.filter(product => {
      const matchesCategory = selectedCategory === 'All' ||
        product.categories[0].name === selectedCategory;
      const matchesSearch = product.productId.toString().includes(searchProductId);
      return matchesCategory && matchesSearch;
    });
  }, [products, selectedCategory, searchProductId]);

  const paginatedProducts = useMemo(() => {
    return filteredProducts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredProducts, page, rowsPerPage]);

  const handleEditProduct = async () => {
    try {
      const salePrice = selectedProduct.originalPrice * (1 - selectedProduct.discount / 100);
      const updatedProductData = {
        ...selectedProduct,
        salePrice: Math.round(salePrice)
      };
      await axios.put(`/api/products/${selectedProduct._id}`, updatedProductData);
      const response = await axios.get('/api/all/products');
      setProducts(response.data);
      setOpenEditModal(false);
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };

  const handleDelete = async (productId) => {
    try {
      await axios.delete(`/api/products/${productId}`);
      setProducts(products.filter(product => product._id !== productId));
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return "/api/placeholder/48/48";
    const cleanUrl = imageUrl.trim();
    if (cleanUrl.startsWith('http')) return cleanUrl;
    const baseUrl = '';
    const imagePath = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;
    return `${baseUrl}${imagePath}`;
  };

  const TabPanel = ({ children, value, index }) => (
    <div hidden={value !== index}>
      {value === index && children}
    </div>
  );
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleImageUpload = async (event, productName) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('productName', productName);

    try {
      const response = await axios.post(
        '/api/products/upload-image',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            setUploadProgress(progress);
          },
        }
      );

      if (response.data.url) {
        const newImage = {
          url: response.data.url,
          fileName: file.name,
          _id: response.data._id || Date.now().toString(),
        };

        setSelectedProduct(prev => ({
          ...prev,
          images: [...prev.images, newImage]
        }));
      }
      setUploadProgress(0);
    } catch (error) {
      console.error('Error uploading image:', error);
      setUploadProgress(0);
    }
  };

  const handleRemoveImage = async (imageId) => {
    try {
      await axios.delete(`/api/products/${selectedProduct._id}/images/${imageId}`);
      
      setSelectedProduct(prev => ({
        ...prev,
        images: prev.images.filter(img => img._id !== imageId)
      }));
    } catch (error) {
      console.error('Error removing image:', error);
    }
  };
  return (
    <>
    <section>
      <div className="tf-page-title style-2">
        <div className="container-full">
          <div className="heading text-center">Stock Management</div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <AdminHome />
          <div className='col-lg-9'>
            <Typography variant="h4" className="mb-6"></Typography>

            <Paper className="mb-6 p-4">
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Search by Product ID"
                    variant="outlined"
                    value={searchProductId}
                    onChange={(e) => setSearchProductId(e.target.value)}
                    fullWidth
                    size="small"
                    style={{fontFamily: 'Raleway, serif'}}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Filter by Category</InputLabel>
                    <Select
                      value={selectedCategory}
                      label="Filter by Category"
                      onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                      {categories.map((category) => (
                        <MenuItem key={category} value={category}>{category}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>

            <Paper>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Product Image</TableCell>
                      <TableCell>Product ID</TableCell>
                      <TableCell>Product Name</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Price Details</TableCell>
                      <TableCell>Size Available</TableCell>
                      <TableCell>Material</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedProducts.map((product) => (
                      <TableRow key={product._id}>
                        <TableCell>
                          <div className="w-12 h-12">
                          <img
                  src={getImageUrl(product.images[0]?.url)}
                  alt={product.productName}
                  className="w-full h-full object-cover rounded"
                  onError={(e) => {
                    console.error('Image failed to load:', product.images[0]?.url);
                    e.target.src = "/api/placeholder/48/48";
                  }}
                />
                          </div>
                        </TableCell>
                        <TableCell>{product.productId}</TableCell>
                        <TableCell>
                          <Typography variant="body2">{product.productName}</Typography>
                          <Typography variant="caption" color="textSecondary" className="line-clamp-1">
                            {product.description}
                          </Typography>
                        </TableCell>
                        <TableCell>{product.categories[0].name}</TableCell>
                        <TableCell>
                          <Typography variant="body2">₹{product.originalPrice}</Typography>
                          <Typography variant="caption" color="error">-{product.discount}%</Typography>
                          <Typography variant="body2" color="primary">₹{product.salePrice}</Typography>
                        </TableCell>
                        <TableCell>
                          <div className="flex flex-wrap gap-1 max-w-[200px]">
                            {product.size.map((sizeItem) => (
                              <Chip
                                key={sizeItem.sizeId}
                                label={`Size: ${sizeItem.size}, Quantity: ${sizeItem.quantity}`}
                                size="small"
                                color={sizeItem.quantity > 0 ? "success" : "error"}
                              />
                            ))}
                          </div>
                        </TableCell>
                        <TableCell>{product.material}</TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setSelectedProduct(product);
                                setOpenEditModal(true);
                              }}
                            >
                              Edit
                            </Button>
                            <IconButton
                              color="error"
                              onClick={() => handleDelete(product._id)}
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={filteredProducts.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
            </Paper>

            <Dialog
              open={openEditModal}
              onClose={() => setOpenEditModal(false)}
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle>
                Edit Product Details
                <IconButton
                  onClick={() => setOpenEditModal(false)}
                  className="absolute right-2 top-2"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                {selectedProduct && (
                  <Box>
                    <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
                      <Tab label="Basic Details" />
                      <Tab label="Inventory" />
                      <Tab label="Images" />
                      <Tab label="Delivery" />
                    </Tabs>

                    <TabPanel value={activeTab} index={0}>
                      <Grid container spacing={3} className="mt-4">
                        <Grid item xs={6}>
                          <TextField
                            label="Product Name"
                            fullWidth
                            value={selectedProduct.productName}
                            onChange={(e) => setSelectedProduct({
                              
                              ...selectedProduct,
                              productName: e.target.value
                            })}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            label="Material"
                            fullWidth
                            value={selectedProduct.material}
                            onChange={(e) => setSelectedProduct({
                              ...selectedProduct,
                              material: e.target.value
                            })}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            label="Description"
                            fullWidth
                            multiline
                            rows={3}
                            value={selectedProduct.description}
                            onChange={(e) => setSelectedProduct({
                              ...selectedProduct,
                              description: e.target.value
                            })}
                          />
                        </Grid>
                      </Grid>
                    </TabPanel>

                    <TabPanel value={activeTab} index={1}>
                      <TableContainer className="mt-4">
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Size</TableCell>
                              <TableCell>Size ID</TableCell>
                              <TableCell>Quantity</TableCell>
                              <TableCell>Status</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedProduct.size.map((sizeItem, index) => (
                              <TableRow key={sizeItem.sizeId}>
                                <TableCell>{sizeItem.size}</TableCell>
                                <TableCell>{sizeItem.sizeId}</TableCell>
                                <TableCell>
                                  <TextField
                                    type="number"
                                    value={sizeItem.quantity}
                                    onChange={(e) => {
                                      const updatedSizes = [...selectedProduct.size];
                                      updatedSizes[index].quantity = parseInt(e.target.value);
                                      setSelectedProduct({
                                        ...selectedProduct,
                                        size: updatedSizes
                                      });
                                    }}
                                    size="small"
                                  />
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label={sizeItem.quantity > 0 ? "In Stock" : "Out of Stock"}
                                    color={sizeItem.quantity > 0 ? "success" : "error"}
                                    size="small"
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TabPanel>

                   
                    <TabPanel value={activeTab} index={2}>
      <Box sx={{ mb: 2 }}>
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="raised-button-file"
          multiple
          type="file"
          onChange={(e) => handleImageUpload(e, selectedProduct.productName)}
        />
        <label htmlFor="raised-button-file">
          <Button
            variant="contained"
            component="span"
            startIcon={<CloudUploadIcon />}
          >
            Upload New Image
          </Button>
        </label>
        {uploadProgress > 0 && (
          <LinearProgress 
            variant="determinate" 
            value={uploadProgress} 
            sx={{ mt: 1 }}
          />
        )}
      </Box>

      <ImageList cols={3} gap={16} className="mt-4">
        {selectedProduct?.images.map((image, index) => (
          <ImageListItem 
            key={image._id || index}
            sx={{ position: 'relative' }}
          >
            <img
              src={getImageUrl(image.url)}
              alt={`Product ${index + 1}`}
              className="w-full h-32 object-cover rounded"
              onError={(e) => {
                console.error('Image failed to load:', image.url);
                e.target.src = "/api/placeholder/300/128";
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                bgcolor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '0 0 0 8px'
              }}
            >
              <IconButton
                size="small"
                onClick={() => handleRemoveImage(image._id)}
                sx={{ color: 'white' }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
            <Typography variant="caption" display="block" textAlign="center">
              {image.fileName}
            </Typography>
          </ImageListItem>
        ))}
      </ImageList>
    </TabPanel>

                    <TabPanel value={activeTab} index={3}>
                      <Grid container spacing={2} className="mt-4">
                        <Grid item xs={12}>
                          <Typography variant="h6">Delivery Duration (Days)</Typography>
                        </Grid>
                        {selectedProduct.deliveryDuration.map((duration, index) => (
                          <Grid item xs={2} key={index}>
                            <TextField
                              label={`Option ${index + 1}`}
                              type="number"
                              fullWidth
                              value={duration}
                              size="small"
                              onChange={(e) => {
                                const updatedDuration = [...selectedProduct.deliveryDuration];
                                updatedDuration[index] = parseInt(e.target.value);
                                setSelectedProduct({
                                  ...selectedProduct,
                                  deliveryDuration: updatedDuration
                                });
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </TabPanel>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenEditModal(false)}>Cancel</Button>
                <Button onClick={handleEditProduct} variant="contained" color="primary">
                  Save Changes
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>

      {/* <div className="btn-sidebar-account">
        <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
          <i className="icon icon-sidebar-2"></i>
        </button>
      </div> */}

      <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
        <div className="canvas-wrapper">
          <header className="canvas-header">
            <span className="title">SIDEBAR ACCOUNT</span>
         
            <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
          </header>
          <div className="canvas-body sidebar-mobile-append"></div>
          </div>
        </div>
     
    </section>

 <div className="btn-sidebar-account">
                          <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                              <BsMenuButtonWideFill />
                          </button>
                      </div>
          
                      <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                          <div className="canvas-wrapper">
                              <header className="canvas-header">
                                  <span className="title">SIDEBAR ACCOUNT</span>
                                  {/* <SideNavbaBarDashboard /> */}
                                  <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                              </header>
                              
                              <div className="canvas-body sidebar-mobile-append"> </div>
                          </div>
                      </div>
</>
  );
};

export default AllProducts;

